import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import Footer from "../components/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col">
      <header className="container-bsp h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-[#1A1F3D] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-[#D4A853]" />
          </div>
          <span className="font-display text-xl text-[#1A1F3D]">BrandSnapPro™</span>
        </Link>
        <Link to="/" className="text-sm text-[#52525b] inline-flex items-center gap-1.5 hover:text-[#1A1F3D]">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
      </header>
      <main className="flex-1 container-bsp py-16 max-w-3xl">
        <span className="eyebrow">Legal</span>
        <h1 className="font-display text-4xl md:text-5xl text-[#1A1F3D] mt-3">Terms of Service</h1>
        <p className="text-[#52525b] mt-2 text-sm">Last updated: {new Date().toLocaleDateString("en-GB", { dateStyle: "long" })}</p>
        <div className="mt-8 space-y-5 text-[#2D2D2D] leading-relaxed">
          <p>This is a placeholder terms of service. Replace this content with your full terms before launch.</p>
          <h2 className="font-display text-2xl text-[#1A1F3D] mt-8">Membership</h2>
          <p>Your one-time payment grants you lifetime access to the BrandSnapPro™ guided system as it exists today and any future improvements.</p>
          <h2 className="font-display text-2xl text-[#1A1F3D] mt-8">Acceptable use</h2>
          <p>BrandSnapPro™ guides you through using third-party AI tools to create images of yourself. Don't use the service to generate images of other people without their consent, or for any unlawful purpose.</p>
          <h2 className="font-display text-2xl text-[#1A1F3D] mt-8">Refunds</h2>
          <p>If your results aren't there yet, contact us — we'll work with you one-on-one until they are.</p>
          <h2 className="font-display text-2xl text-[#1A1F3D] mt-8">Contact</h2>
          <p>Questions? Email <a className="gold-link" href="mailto:contact@aicompass.co.uk">contact@aicompass.co.uk</a>.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
